export const DS_EDITOR_ID = "ds"
export const MAX_SERVICES_LENGTH = 59

export const NEW_LISTENER = "newListener"
export const REMOVE_LISTENER = "removeListener"

export const CONNECTION_STATE = "connectionState"
export const CONNECT = "connect"
export const LOST = "lost"
export const FOUND = "found"
export const CONNECTING = "connecting"
export const DISCONNECT = "disconnect"
export const DISCONNECTING = "disconnecting"
export const ANNOUNCE = "announce"
export const START = "start"
export const RESTART = "restart"
export const STOP = "stop"
export const CHANGE = "change"
export const EVENT = "event"
export const RENDER = "render"
export const REFRESH = "refresh"
export const MESSAGE = "message"

export const ERROR = "error"
export const PANIC = "panic"
export const TRACE = "trace"
export const TIMEOUT = "timeout"
export const TIMEOUT_DISCONNECT = "timeoutDisconnect"

export type DataType = "string" | "number" | "boolean"